import { ReactNode } from 'react';

interface ListPageShellProps {
	title: string;
	subtitle?: string;
	recordCount?: number;
	chips?: ReactNode;
	toolbar?: ReactNode;
	primaryActions?: ReactNode;
	metrics?: ReactNode;
	children: ReactNode;
}

/**
 * Shared shell for the Contacts / Companies / Deals list pages. Provides the
 * HubSpot-style header (title + count + actions), the saved-view chip row,
 * an optional metrics dashboard row, the toolbar, and the data area.
 */
export function ListPageShell({
	title,
	subtitle,
	recordCount,
	chips,
	toolbar,
	primaryActions,
	metrics,
	children
}: ListPageShellProps) {
	return (
		<div className="p-4 md:p-6 space-y-4">
			<div className="flex flex-wrap items-start justify-between gap-3">
				<div className="min-w-0">
					<div className="flex items-baseline gap-2">
						<h1 className="text-2xl font-semibold text-foreground">{title}</h1>
						{typeof recordCount === 'number' && (
							<span className="text-sm text-muted-foreground">{recordCount.toLocaleString()} record{recordCount === 1 ? '' : 's'}</span>
						)}
					</div>
					{subtitle && <p className="mt-0.5 text-sm text-muted-foreground">{subtitle}</p>}
				</div>
				{primaryActions && <div className="flex items-center gap-2">{primaryActions}</div>}
			</div>

			{chips}

			{metrics}

			{toolbar}

			<div className="rounded-lg border bg-card">{children}</div>
		</div>
	);
}
